import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { custodiansSelector } from 'store/reducers/favouriteCustodians.reducer';
import { searchCustodians, searchCustodiansForSuggestions } from 'store/actions/favouriteCustodians.action';
import { Input } from '../Input/Input';
import { Button } from '../Button/Button';
import { FoundCustodianSection } from 'components/grid';
import { InputLabel } from '../InputLabel/InputLabel';
import { Select } from '..';
import { FoundCustodian } from 'types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Form, Field } from 'react-final-form'
import { Topography } from 'components/ui'
import checkIcons from 'assets/images/check-circle.png';
import closeIcons from 'assets/images/font-icons/close.svg'
import InputMask from 'react-input-mask'
import cookies from '../../../store/apis/cookies'

import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import styles from '../../ui/CustodianCard/CustodianCard.module.scss';
import { event } from 'react-ga';
import { Preloader } from 'components/ui';

export type SelectedCustodian = {
  id: number | null;
  name: string;
  latitude: number;
  longitude: number;
  forms?: any;
  selectedLocation?: string | null;
  selectedSiteLocationName?: string | null;
};

export type MapSearchProps = {
  className?: string;
  onClick: (data: SelectedCustodian) => void;
  isFormRequest: boolean;
};



const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']

export const MapSearch: React.FC<any> = ({ onClick, isFormRequest }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false)
  const [isSuggestModalOpen, setSuggestModalOpen] = useState(false)
  const [errorState, setErrorState] = useState<any | ''>()
  const [errorName, setErrorName] = useState<any | ''>()
  const [errorOrgName, setErrorOrgName] = useState<any | ''>()
  const [errorOrgState, setErrorOrgState] = useState<any | ''>()
  const [errorOrgFax, setErrorOrgFax] = useState<any | ''>()
  const [errorOrgPhone, setErrorOrgPhone] = useState<any | ''>()
  const [errorOrgCity, setErrorOrgCity] = useState<any | ''>()
  const [organizationName, setOrganizationName] = useState<any | ''>()
  const [organizationCity, setOrganizationCity] = useState<any | ''>()
  const [organizationFax, setOrganizationFax] = useState<any | ''>()
  const [organizationState, setOrganizationState] = useState<any | ''>()
  const [organizationPhone, SetOrganizationPhone] = useState<any | ''>()
  const [exactMatch, setExactMatch] = useState(true)
  const [suggestProvider, setSuggestProvider] = useState(true)
  const [disableInput, setDisableInput] = useState(true)
  const [mobile, setMobile] = useState<string>('')
  const [searchData, setSearchData] = useState<any>({
    searching: false,
    totalCustodians: 0,
    name: '',
    state: '',
  });

  const { foundCastodians, isDetailsLoading, isSearching } = useSelector(custodiansSelector);

  const [selectedCustodian, setSelectedCustodian] = useState<SelectedCustodian>({ id: null, name: '', latitude: 40.743791, longitude: -74.170693 });
  const [custodians, setCustodians] = useState<FoundCustodian[]>([])
  const [showSearch, setSearch] = React.useState(false)
  const [showBtnSearch, setBtnSearch] = React.useState(false)
  const [isAdvanceSearch, setAdvanceSearch] = useState(false)
  const [inputDisabled, setInputDisabled] = useState<String>('disabled' || null)
  const [resultType, setResultType] = React.useState(true)
  const [typeHeaddata, setTypeHeaddata] = useState<any>('' || null);
  const [suggestiveCustodians, setSuggestiveCustodians] = useState<any>([]);
  const [advanceSearchData, SetAdvanceSearchData] = useState<any>([{
    name: '',
    fax: '',
    state: '',
    city: ''
  }])

  const handleSelect = (data: SelectedCustodian) => {
    setSelectedCustodian(data)
    onClick(data)
  };

  useEffect(() => {
    let timer:any;
    timer = setTimeout(()=>{
      if(typeHeaddata !== null && typeHeaddata.lenght !== 0 ) {
        dispatch(
          searchCustodiansForSuggestions({state: searchData.state, name: searchData.name, ...data }, isFormRequest, false, (data: any) => {
            setSearchData((state: any) => ({ ...state, searching: false, totalCustodians: data.total_custodians }));
            setSuggestiveCustodians(data.custodians)
          }),
         )
      }
    }, 300)
    return () => clearTimeout(timer);
  }, [typeHeaddata])

  const handleScroll = () => {
    let custodianScroolContainer = document.querySelector('#custodianScroolContainer')
    if (!custodianScroolContainer) return;
    if (
      custodianScroolContainer.scrollTop + custodianScroolContainer.clientHeight > custodianScroolContainer.scrollHeight - 100 &&
      searchData.totalCustodians &&
      foundCastodians &&
      foundCastodians.length < searchData.totalCustodians &&
      !searchData.searching
    ) {
      setSearchData((state: any) => ({ ...state, searching: true }));
      dispatch(
        searchCustodians({ name: searchData.name, state: searchData.state, page: Math.floor(foundCastodians.length / 10) + 1 }, isFormRequest, true, data => {
          setSearchData((state: any) => ({ ...state, searching: false }));
        }),
      );
    }
  };

  const onChange = (data: any, key: any) => {
    if (key === 'Enter') {
      setBtnSearch(true);
    } else {
      setBtnSearch(false);
    }
    if (searchData.state !== '') {
      setSearchData({ ...searchData, ...data });
      onSearch(data)
    }
    setResultType(true);

  }
  const onSelectChange = (data: any) => {
    if (data.state !== '') {
      setErrorState('')
      setSearchData({ ...searchData, ...data, searching: true });
      setSuggestiveCustodians([])
      dispatch(
        searchCustodiansForSuggestions({state: searchData.state, name: searchData.name, ...data }, isFormRequest, false, (data: any) => {
          setSearchData((state: any) => ({ ...state, searching: false, totalCustodians: data.total_custodians }));
          setSuggestiveCustodians(data.custodians)
        }),
      );
      // onSearch(data)
      setDisableInput(false)
      setBtnSearch(false)
    }
  }
  const onSearch = (data: { name?: string, state?: string }) => {
    dispatch(
      searchCustodians({ name: searchData.name, state: searchData.state, ...data }, isFormRequest, false, (data: any) => {
        setSearchData((state: any) => ({ ...state, totalCustodians: data.total_custodians }));
      }),
    );
  };
  const onSearchBtn = (data: { name?: string, state?: string }) => {
    let stateId = document.getElementById('custodian-state');
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    stateId?.classList.add('prevent_pointer');
    if (searchData.state == '') {
      setErrorState('error_input')
    } else {
      setErrorState('')
    }
    if (typeHeaddata === '' || typeHeaddata === null) {
      setErrorName('error_input')
    } else {
      setErrorName('')
    }
    if (typeHeaddata === '' || searchData.state === '' || typeHeaddata === null) {

    } else {
      dispatch(
        searchCustodians({ name: typeHeaddata, state: searchData.state, ...data }, isFormRequest, false, (data: any) => {
          setSearchData((state: any) => ({ ...state, totalCustodians: data.total_custodians }));
          setResultType(data.is_result_record_found);
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          stateId?.classList.remove('prevent_pointer');
        }),
      );
      setBtnSearch(true);
      setSearch(false);
    }
  };
  const toggleModal = () => {
    setModalOpen(!isModalOpen)
    setAdvanceSearch(false)
    setErrorOrgName('')
    setErrorOrgCity('')
    setErrorOrgState('')
    setErrorOrgFax('')
    setErrorOrgPhone('')
    setSuggestProvider(true)
    setExactMatch(true)
    setOrganizationFax('')
    setResultType(true);

  }
  const openSuggestModal = () => {
    setSuggestModalOpen(!isSuggestModalOpen)
    setModalOpen(!isModalOpen)
    setErrorOrgName('')
    setErrorOrgCity('')
    setErrorOrgState('')
    setErrorOrgFax('')
    setErrorOrgPhone('')
    setOrganizationFax('')
    SetOrganizationPhone('')
  }
  const closeSuggestModal = () => {
    setSuggestModalOpen(!isSuggestModalOpen)
    setSuggestProvider(true)
    setExactMatch(true)
  }
  const handleSubmit = (values: any, data: any, extraHeaders: any = {}) => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL
    if (values.organizationLocationCity) {
      if (values.organizationName == undefined || values.organizationLocationCity == undefined || organizationFax == undefined || organizationFax.trim().length < 15 || values.organizationState == undefined || values.organizationState == 'Required' || organizationPhone.trim().length) {
        if (values.organizationName == undefined) {
          setErrorOrgName('error_input')
        }
        if (values.organizationLocationCity === undefined) {
          setErrorOrgCity('error_input')
        }
        if (values.organizationState === undefined || values.organizationState === 'Required') {
          setErrorOrgState('error_input')
        }
        if (organizationFax == undefined || organizationFax == '') {
          setErrorOrgFax('error_input')
        }
        if (organizationPhone.trim().length < 15) {
          setErrorOrgPhone('error_input')
        }
      } else {
        fetch(baseUrl + "/api/v2/provider_signups/suggested_provider_search", {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
            'authorization-token': cookies.load('authToken'),
            'authorization': process.env.REACT_APP_AUTHORIZATION_HEADER,
            ...extraHeaders
          }),
          body: JSON.stringify({
            "name": values.organizationName,
            "address1": values.organizationLocationName,
            "city": values.organizationLocationCity,
            "state": values.organizationState,
            "fax": organizationFax,
            "phone": values.organizationPhone,
            "zipcode": values.OrganizationZip
          })
        })
          .then((response) => response.json())
          .then((data) => {
            setSuggestProvider(false)
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    } else {
      setOrganizationName(values.organizationName)
      setOrganizationCity(values.organizationCity)
      setOrganizationFax(organizationFax)
      setOrganizationState(values.organizationState)
      if (values.organizationName === undefined || values.organizationCity === undefined || organizationFax === undefined || organizationFax.trim().length < 15 || values.organizationState === undefined || organizationFax === '' || values.organizationState === 'Required') {
        if (values.organizationName === undefined) {
          setErrorOrgName('error_input')
        }
        if (values.organizationCity === undefined) {
          setErrorOrgCity('error_input')
        }
        if (values.organizationState === undefined || values.organizationState === 'Required') {
          setErrorOrgState('error_input')
        }
        if (organizationFax === '' || organizationFax.trim().length < 15) {
          setErrorOrgFax('error_input')
        }
        if (organizationFax == '' || organizationFax.trim().length < 15) {
          setErrorOrgPhone('error_input')
        }
      } else {
        SetAdvanceSearchData({
          name: values.organizationName, city: values.organizationCity, state: values.organizationState, fax: organizationFax
        })
        dispatch(
          searchCustodians({ name: values.organizationName, city: values.organizationCity, state: values.organizationState, fax: organizationFax, zipcode: values.organizationZip, ...data }, isFormRequest, false, (data: any) => {
            setSearchData((state: any) => ({ ...state, totalCustodians: data.total_custodians }));
            setErrorOrgName('')
            setErrorOrgCity('')
            setErrorOrgState('')
            setErrorOrgFax('')
            setErrorOrgPhone('')
            if (data.is_result_record_found) {
              setExactMatch(true)
            } else {
              setExactMatch(false)
            }
          }),
        );
        setSearch(false)
        setAdvanceSearch(true)
      }
    }
  }
  const removeClass = (feildName: any) => {
    if (feildName === errorOrgName) {
      setErrorOrgName('')
    }
    if (feildName === errorOrgFax) {
      setErrorOrgFax('')
    }
    if (feildName == errorOrgPhone) {
      setErrorOrgPhone('')
    }
    if (feildName == errorOrgState) {
      setErrorOrgState('')
    }
    if (feildName === errorOrgCity) {
      setErrorOrgCity('')
    }
    if (feildName === errorName) {
      setErrorName('')
    }
    if (feildName === errorState) {
      setErrorState('')
    }
  }
 const onSelectTypeHead = (result: any, event:any) =>{
   if(result[0]){
    handleSelect(result[0]);
   }
 }

 const handleKeyDown = (result: any, ev:any) =>{
  if(result.key === 'Tab' || result.key === undefined ) return
  if(result.key === 'Enter' && typeHeaddata != null && typeHeaddata != ''){
    let hideEle:any = document.getElementById('custodian_type_head');
    let data = {
      state: searchData.state,
      name: searchData.name
      }
    onSearchBtn(data)
    hideEle.style.display = "none";
   }
 }
 const setCustodianName = (text: any, event:any) =>{
   let hideEle:any = document.getElementById('custodian_type_head');
   setSuggestiveCustodians([])
   setErrorName('')
   setSearch(true)
   setSearchData((state: any) => ({ ...state, name: text, searching: true }));
   setBtnSearch(false)
   setTypeHeaddata(text);
   if(hideEle != null){
    hideEle.style.display = "block";  
   }
 }
 const onBlur = () => {
  setSearch(false)
  let serchname:any  = document.querySelector('.rbt-input');
  setTypeHeaddata(serchname.value);
 }

  const onFilter = (option:any, props: any) => {
    const query = props.text.toLowerCase();
    const name = option.name.toLowerCase();
    return name.startsWith(query);
  }

  const _renderMenu = (results:any, menuProps:any) => {
    if(searchData.searching) {
      return(<Menu {...menuProps}>
              <MenuItem option="" position={1}> 
                <Preloader className='mx-auto'/>
              </MenuItem>
            </Menu>)
    }
    const items = results.map((result:any, index:any) => {  
      if(result.location_name?.length === 0) return (<MenuItem key={index} option={result} position={index}> 
        <div className={styles['root']}>
          <div className='col-md-9'>
            <div className='justify-self-start'>
              <div className={`d-flex align-items-center`}>
                <Topography.H4>{result.name}</Topography.H4>
                {result.enterprise && <div className='ml-2'>&bull; {result.enterprise}</div>}
                {result.alias && <div className='ml-2'>&bull; <span className={styles.alias}>{result.alias}</span></div>}
              </div>
              <p className='custom_txt_wrap'>{result.descripton}</p>
              {result.specialty.length > 0 && (<div className='mt-2 custom_txt_wrap'><b>Specialty</b>:- {result.specialty?.join(', ')}</div>)}
            </div>
          </div>
        </div>
      </MenuItem>);

      return(
        <MenuItem key={index} option={{...result, selectedLocation: result.location_address, selectedSiteLocationName: result.location_id ? result.name : null}} position={index}>
          <div className={styles['root']}>
            <div className='col-md-9'>
              <div className='justify-self-start' key={index}>
                <div className={`d-flex align-items-center`}>
                  <Topography.H4 className='cus_name_heading'>{result.name}</Topography.H4>
                  {result.enterprise && <div className='ml-2'>&bull; {result.enterprise}</div>}
                  {result.alias && <div className='ml-2'>&bull; <span className={styles.alias}>{result.alias}</span></div>}
                </div>
                <p className='custom_txt_wrap'>{result.location_address}</p>
                {result.specialty.length > 0 && (<div className='mt-2 custom_txt_wrap'><b>Specialty</b>:- {result.specialty?.join(', ')}</div>)}
              </div>
            </div>
            <div className='align-self-start justify-self-end ml-3 mt-3'>
              <button className='btn_custodian' name='' value=''> Select Provider </button>
            </div>
          </div>
        </MenuItem>
      );
    });
    return <Menu {...menuProps}>{items}</Menu>;
  }

  return (
    <div className='row pb-3 main_search_wrapper'>
      <div className='col-12 mb-3'>
        <div className='mb-3 row'>
          <div className='col-12 col-md-3 mb-3'>
            <Select className={errorState} id="custodian-state" options={[{ label: 'Select State', value: '' }].concat(states.map(state => ({ label: state, value: state })))} maxLength={25} onChange={(val: any) => onSelectChange({ state: val.value })} value={{ label: searchData.state || 'Required', value: searchData.state || '' }} onFocus={() => removeClass(errorState)} />
            <InputLabel text='Select the state your provider is in' className='custodian_label' />
          </div>
          {resultType ? (
            null
          ) : (<div className='no_result_txt'><strong>No exact matches for "State:{searchData.state}, Name:{typeHeaddata}" see our suggested providers near you.</strong></div>)}
          <div className='col-12 col-md-7 mb-3'>
            {/* <Input id="cusFacname"  className={errorName} disabled={disableInput} type="text" style={{ fontSize: '14px' }} onKeyPress={e => e.key == 'Enter' && onChange({ changed: false }, e.key)} onChange={(e: any) => onChange({ name: e.target.value, changed: !!e.target.value }, e.key)} value={searchData.name} placeholder="Required" /> */}
            
            <Typeahead className={errorName+' custom_type_head'}
                maxResults={2000}
                options={suggestiveCustodians}
                labelKey='name'
                renderMenu={_renderMenu}
                placeholder="Required"
                id="custodian_type_head"
                disabled={disableInput}
                onChange={(ev)=>{onSelectTypeHead(ev, event)}}
                onKeyDown={(ev)=>{handleKeyDown(ev, event)}}
                onBlur = {onBlur}
                onFocus={()=>removeClass(errorName)}
                filterBy={onFilter}
                onInputChange={(text, event)=>{setCustodianName(text, event)}}
            />
            {showSearch ? (
              <div className='suggestive_hint' style={{ color: '#4683B4' }}>Press enter or return to see full results or press tab to select suggested provider.</div>
            ) : null}
            <InputLabel text='Search by facility name' className='custodian_label' />
            <div className='advance_search_txt'>Don’t see your provider? Try our <span className='adv_search' onClick={toggleModal}> Advanced Search</span></div>
          </div>
          <div className='col-12 col-md-auto search_btn'>
            <Button onClick={() => onSearchBtn({})} className='btn-block px-3 main_src_btn'>Search</Button>
          </div>
        </div>
        {showBtnSearch ? (
          <div>
            <p className='sel_one_provider'><strong>Please select only one provider</strong></p>
            <FoundCustodianSection
              foundCustodians={foundCastodians}
              isPreloader={isSearching}
              selected={selectedCustodian}
              handleSelect={handleSelect}
              searchData={searchData}
              onScroll={handleScroll}
              isDetailsLoading={isDetailsLoading}
              isFormRequest={isFormRequest}
            />
          </div>
        ) : (null)}
      </div>
      <div className='advance_serch_modal'>
        <Modal centered isOpen={isModalOpen} toggle={toggleModal} className="modal advance_search_modal" backdrop="static">
          <ModalHeader toggle={toggleModal}>
            <h4>Advanced Search</h4>
            <p className='modal_custom_txt'>Search by any field below</p>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit} render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit} className='row'>
                <div className='row'>
                  <div className='col-12 col-md-4 mb-3'>
                    <label>Organization Name</label>
                    <Field className={errorOrgName} name="organizationName" onFocus={() => removeClass(errorOrgName)} component="input" placeholder="Required" />
                  </div>
                  <div className='col-12 col-md-4 mb-3'>
                    <label>Organization Fax Number</label>
                    <InputMask mask="+1 999-999-9999" className={errorOrgFax} type="text" placeholder="Required" name="organizationFax" value={organizationFax} onChange={event => setOrganizationFax(event.target.value)} onFocus={() => removeClass(errorOrgFax)} />
                  </div>
                  <div className='col-12 col-md-4 mb-3'>
                    <label>State</label>
                    <Field name="organizationState" component="select" className={"org_state_name " + errorOrgState} onFocus={() => removeClass(errorOrgState)}>
                      <option selected>Required</option>
                      {states.map((state) =>
                        <option value={state}>{state}</option>
                      )}
                    </Field>
                  </div>
                  <div className='col-12 col-md-4 mb-3'>
                    <label>City</label>
                    <Field className={errorOrgCity} component="input" type="text" placeholder="Required" name="organizationCity" onFocus={() => removeClass(errorOrgCity)} />
                  </div>
                  <div className='col-12 col-md-4 mb-3'>
                    <label>Zip Code</label>
                    <Field type="text" component="input" placeholder="Optional" name="organizationZip" maxlength="10" />
                  </div>
                </div>
                {exactMatch ? null : (
                  <p className='no_match_txt'>No exact matches for "Organization Name : {advanceSearchData.name} , Organization Fax Number: {advanceSearchData.fax} , State: {advanceSearchData.state} , City: {advanceSearchData.city}", see our suggested providers near you</p>
                )}
                {isAdvanceSearch ? (
                  <FoundCustodianSection
                    foundCustodians={foundCastodians}
                    isPreloader={isSearching}
                    selected={selectedCustodian}
                    handleSelect={handleSelect}
                    searchData={searchData}
                    onScroll={handleScroll}
                    isDetailsLoading={isDetailsLoading}
                    isFormRequest={isFormRequest}
                  />
                ) : null}
                <div className='custom_modal_footer'>
                  <div className='ft_item_one'>
                    <Button className='w-auto pull-left cancel_btn' onClick={toggleModal}>Cancel</Button>
                  </div>
                  {exactMatch ? null : (
                    <div className='ft_item_two'>
                      Still don’t see your provider? <span className='adv_search' onClick={openSuggestModal}> Suggest a Provider </span>
                    </div>
                  )}
                  <div className='ft_item_three'>
                    <Button htmlType="submit" className='w-auto px-4 adv_search_btn'>Search</Button>
                  </div>
                </div>

              </form>

            )} />
          </ModalBody>
        </Modal>
        <Modal centered isOpen={isSuggestModalOpen} toggle={openSuggestModal} className="modal advance_search_modal" data-backdrop="static" data-keyboard="false">
          {suggestProvider ? (
            <ModalHeader toggle={openSuggestModal}>
              <h4>Suggest New Provider</h4>
              <p className='modal_custom_txt'>Please input details for the provider you are looking for. Our Client Services team will review your submission and add the provider to our network for future requests.</p>
            </ModalHeader>
          ) : null}

          <ModalBody>
            {suggestProvider ? (
              <Form onSubmit={handleSubmit} render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className='row'>
                  <div className='row col-12'>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Organization Name</label>
                      <Field className={errorOrgName} type="text" component="input" placeholder="Required" name="organizationName" onFocus={() => removeClass(errorOrgName)} />
                    </div>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Location Name</label>
                      <Field type="text" component="input" placeholder="Optional" name="organizationLocationName" />
                    </div>
                  </div>
                  <div className='row col-12'>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>City</label>
                      <Field type="text" className={errorOrgCity} onFocus={() => removeClass(errorOrgCity)} component="input" placeholder="Required" name='organizationLocationCity' />
                    </div>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>State</label>
                      <Field name="organizationState" component="select" onFocus={() => removeClass(errorState)} className={"org_state_name " + errorOrgState}>
                        <option selected>Required</option>
                        {states.map((state) =>
                          <option value={state}>{state}</option>
                        )}
                      </Field>
                    </div>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Zip Code</label>
                      <Field type="text" placeholder="Optional" component="input" name='OrganizationZip' maxlength="10" />
                    </div>
                  </div>
                  <div className='row col-12'>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Organization Fax Number</label>
                      <InputMask mask="+1 999-999-9999" className={errorOrgFax} type="text" placeholder="Required" name="organizationFax" value={organizationFax} onChange={event => setOrganizationFax(event.target.value)} onFocus={() => removeClass(errorOrgFax)} />
                    </div>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Organization Phone Number</label>
                      <InputMask mask="+1 999-999-9999" className={errorOrgPhone} placeholder="Optional" name="organizationPhone" value={organizationPhone} onChange={event => SetOrganizationPhone(event.target.value)} onFocus={() => removeClass(errorOrgPhone)} />
                    </div>
                    <div className='col-12 col-md-4 mb-3'>
                      <label>Provider Email</label>
                      <Field type="text" placeholder="Optional" component="input" name="organizationEmail" />
                    </div>
                  </div>
                  <div className='custom_modal_footer'>
                    <div className='ft_item_one'>
                      <Button className='w-auto pull-left cancel_btn' onClick={closeSuggestModal}>Cancel</Button>
                    </div>
                    <div className='ft_item_three'>
                      <Button htmlType="submit" className='w-auto px-4 adv_search_btn'>Suggest Provider</Button>
                    </div>
                  </div>
                </form>

              )} />
            ) : (
              <div className='suggest_provider_sucess'>
                <div className='sug_header'>New Provider Suggested! <span className='close_icons' onClick={closeSuggestModal}><img alt="" src={closeIcons} /></span></div>
                <div className='check_img_wrapper'>
                  <img alt="" src={checkIcons} className="check_right_icons" />
                  <p className='suggest_fotter_txt'>Thank you for your submission! The ChartRequest Team will <br /> review your suggestion.</p>
                  <p className='suggest_fotter_txt'>We will contact you via your work email once we’ve <br />approved your suggested provider.</p>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>

      </div>
    </div>
  );
};
function data(data: any, arg1: { state: any; name: any; }) {
  throw new Error('Function not implemented.');
}